import Cookies from 'js-cookie';

export enum TermsNamesEnum {
	UPLOAD_FILES = 'uploadFilesTerm',
}

export function useTermsOfAgreement() {
	function setTermCookie(name: TermsNamesEnum, expires: number = 1) {
		Cookies.set(name, 'accepted', {expires, secure: true});
	}

	function hasAcceptedTerms(name: TermsNamesEnum) {
		const cookieValue = Cookies.get(name);
		return cookieValue === 'accepted';
	}

	return {
		setTermCookie,
		hasAcceptedTerms,
	};
}
